<div class="card shadow-sm mb-4">
    <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="card-title mb-0">Manage Invoices ({{ invoices().length }})</h5>
            <a routerLink="/invoice" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                class="btn btn-outline-success btn-sm">
                Add Invoice
            </a>
        </div>

        <div class="table-responsive">
            <table class="table table-hover align-middle mb-0">
                <thead class="table-light">
                    <tr>
                        <th>Inv #</th>
                        <th class="d-none d-sm-table-cell">Client</th>
                        <th class="d-none d-md-table-cell">Date</th>
                        <th class="text-end">Total</th>
                        <th class="d-none d-md-table-cell">Status</th>
                        <th class="text-end">Action</th>
                    </tr>
                </thead>

                <tbody>
                    @for (invoice of invoices(); track invoice.id ?? invoice.invoiceMetadata.invoiceNumber) {
                        <tr>
                            <td>{{ invoice.invoiceMetadata.invoiceNumber }}</td>
                            <td class="d-none d-sm-table-cell">{{invoice.clientInfo.name}}</td>
                            <td class="d-none d-md-table-cell">{{ formatDate(invoice.invoiceMetadata.invoiceDate) }}</td>
                            <td class="text-end">{{invoice.companyInfo.address.countryCurrency}} {{ invoice.financialDetails.totalAmount| number:'1.2-2' }} </td>
                            <td class="d-none d-md-table-cell">
                                <span class="badge" [ngClass]="getStatusBadgeClass(invoice.status)">
                                    {{ invoice.status }}
                                </span>
                            </td>
                            <td class="text-end">
                                <div class="d-flex flex-column flex-md-row gap-2 justify-content-end">
                                    <button type="button" class="btn btn-success btn-sm" (click)="openViewModal(invoice)">
                                        View
                                    </button>
                                    <button type="button" class="btn btn-premium btn-sm" (click)="onPdfClick(invoice)">
                                        <i class="bi bi-star-fill"></i> PDF
                                    </button>
                                </div>
                            </td>
                        </tr>
                    } @empty {
                        <tr>
                            <td colspan="6" class="text-center text-muted py-4">No invoices yet. Create one with Add Invoice.</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</div>

<!-- View Invoice Modal -->
@if (showViewModal && selectedInvoice) {
    <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true" style="background: rgba(0,0,0,0.5);">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Invoice {{ selectedInvoice.invoiceMetadata.invoiceNumber }}</h5>
                    <span class="badge ms-2" [ngClass]="getStatusBadgeClass(selectedInvoice.status)">{{ selectedInvoice.status }}</span>
                    <button type="button" class="btn-close" (click)="closeViewModal()" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="row g-3">
                        <div class="col-12">
                            <h6 class="text-muted border-bottom pb-1 mb-2">Details</h6>
                            <div class="row small">
                                <div class="col-md-4"><strong>Invoice #</strong> {{ selectedInvoice.invoiceMetadata.invoiceNumber }}</div>
                                <div class="col-md-4"><strong>Date</strong> {{ formatDate(selectedInvoice.invoiceMetadata.invoiceDate) }}</div>
                                <div class="col-md-4"><strong>Due date</strong> {{ formatDate(selectedInvoice.invoiceMetadata.invoiceDueDate) }}</div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <h6 class="text-muted border-bottom pb-1 mb-2">From</h6>
                            <div class="small">
                                <div class="fw-semibold">{{ selectedInvoice.companyInfo.name }}</div>
                                <div class="text-break">{{ formatAddress(selectedInvoice.companyInfo.address) }}</div>
                                @if (selectedInvoice.companyInfo.email) {
                                    <div>{{ selectedInvoice.companyInfo.email }}</div>
                                }
                                @if (selectedInvoice.companyInfo.phone) {
                                    <div>{{ selectedInvoice.companyInfo.phone }}</div>
                                }
                            </div>
                        </div>
                        <div class="col-md-6">
                            <h6 class="text-muted border-bottom pb-1 mb-2">Bill to</h6>
                            <div class="small">
                                <div class="fw-semibold">{{ selectedInvoice.clientInfo.name }}</div>
                                <div class="text-break">{{ formatAddress(selectedInvoice.clientInfo.address) }}</div>
                                @if (selectedInvoice.clientInfo.email) {
                                    <div>{{ selectedInvoice.clientInfo.email }}</div>
                                }
                                @if (selectedInvoice.clientInfo.phone) {
                                    <div>{{ selectedInvoice.clientInfo.phone }}</div>
                                }
                            </div>
                        </div>
                        <div class="col-12">
                            <h6 class="text-muted border-bottom pb-1 mb-2">Line items</h6>
                            <div class="table-responsive">
                                <table class="table table-sm table-bordered mb-0">
                                    <thead class="table-light">
                                        <tr>
                                            <th>Description</th>
                                            <th class="text-center">Qty</th>
                                            <th class="text-end">Unit price</th>
                                            <th class="text-end">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (item of selectedInvoice.invoiceMetadata.invoiceItems; track item.id ?? $index) {
                                            <tr>
                                                <td>{{ item.description }}</td>
                                                <td class="text-center">{{ item.quantityOrHours }}</td>
                                                <td class="text-end">{{ item.unitPrice | number:'1.2-2' }}</td>
                                                <td class="text-end">{{ (item.total ?? item.quantityOrHours * item.unitPrice) | number:'1.2-2' }}</td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="col-12">
                            <h6 class="text-muted border-bottom pb-1 mb-2">Totals</h6>
                            <div class="row small">
                                <div class="col-md-6 offset-md-6">
                                    <div class="d-flex justify-content-between"><span>Subtotal</span><span>{{ selectedInvoice.financialDetails.subtotal | number:'1.2-2' }}</span></div>
                                    @if (selectedInvoice.financialDetails.discountAmount) {
                                        <div class="d-flex justify-content-between"><span>Discount</span><span>- {{ selectedInvoice.financialDetails.discountAmount | number:'1.2-2' }}</span></div>
                                    }
                                    @if (selectedInvoice.financialDetails.shippingAmount) {
                                        <div class="d-flex justify-content-between"><span>Shipping</span><span>{{ selectedInvoice.financialDetails.shippingAmount | number:'1.2-2' }}</span></div>
                                    }
                                    <div class="d-flex justify-content-between"><span>Tax</span><span>{{ selectedInvoice.financialDetails.taxAmount | number:'1.2-2' }}</span></div>
                                    <div class="d-flex justify-content-between fw-semibold"><span>Total</span><span>{{ selectedInvoice.financialDetails.totalAmount | number:'1.2-2' }}</span></div>
                                </div>
                            </div>
                        </div>
                        @if (selectedInvoice.invoiceMetadata.notes?.trim()) {
                            <div class="col-12">
                                <h6 class="text-muted border-bottom pb-1 mb-2">Notes</h6>
                                <p class="small mb-0 text-break">{{ selectedInvoice.invoiceMetadata.notes }}</p>
                            </div>
                        }
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="closeViewModal()">Close</button>
                    @if (selectedInvoice.id) {
                        <button type="button" class="btn btn-premium" (click)="onPdfClick(selectedInvoice!); closeViewModal()">
                            <i class="bi bi-star-fill"></i> Download PDF
                        </button>
                    }
                </div>
            </div>
        </div>
    </div>
}
